import React from 'react';

import { func, string } from 'prop-types';

import ButtonLink from 'components/Common/Buttons/ButtonLink';

import ButtonV3 from 'components/Common/Buttons/ButtonV3';
import ModalV2 from 'components/Common/ModalV2';
import Text from 'components/Common/Text';

import s from './BackToDashboard.css';

const BackToDashboard = ({ onClose, dashboardUrl }) => (
  <ModalV2
    open
    onClose={onClose}
    title="Back to dashboard"
    dialogClasses={{ root: s.content }}
    classes={{ paper: s.paper }}
    actions={
      <>
        <ButtonV3
          label="Cancel"
          color="gray"
          variant="text"
          onClick={onClose}
        />
        <ButtonLink
          color="gray"
          variant="outlined"
          href={dashboardUrl}
          onClick={onClose}
          label="Go back to Dashboard"
        />
      </>
    }
  >
    <>
      <Text variant="lead" isBold mb={2}>
        Are you sure you want to go back?
      </Text>
      <Text variant="lead">You will lose any unsaved changes.</Text>
    </>
  </ModalV2>
);

BackToDashboard.propTypes = {
  onClose: func.isRequired,
  dashboardUrl: string.isRequired,
};

export default BackToDashboard;
